/* istanbul ignore file */

import { GOOGLE_ADS_GROUP } from "./GoogleAnalyticsGroups";

// aka initGATracking
export function initializeGATracking(
	loginID,
	gaTrackingCode,
	gaTrackingCodeURL
) {
	(function (i, s, o, g, r, a, m) {
		i["GoogleAnalyticsObject"] = r;
		(i[r] =
			i[r] ||
			function () {
				(i[r].q = i[r].q || []).push(arguments);
			}),
			(i[r].l = 1 * new Date());
		(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
		a.async = 1;
		a.src = g;
		!m || m.parentNode.insertBefore(a, m);
	})(
		window,
		document,
		"script",
		"https://www.google-analytics.com/analytics.js",
		"ga"
	);

	const doesLoginIdExist =
		loginID !== undefined && loginID !== "" && loginID !== "-1";

	if (doesLoginIdExist) {
		window.ga("create", gaTrackingCode, "auto", {
			userId: loginID,
			cookieFlags: "secure;samesite=none",
		});
	} else {
		window.ga("create", gaTrackingCode, "auto", {
			cookieFlags: "secure;samesite=none",
		});
	}

	if (gaTrackingCodeURL !== undefined) {
		if (doesLoginIdExist) {
			window.ga("create", gaTrackingCodeURL, "auto", {
				name: "urlTracker",
				userId: loginID,
				cookieFlags: "secure;samesite=none",
			});
		} else {
			window.ga("create", gaTrackingCodeURL, "auto", {
				name: "urlTracker",
				cookieFlags: "secure;samesite=none",
			});
		}
	}

	const ga = function () {
		window.ga(...arguments);
	};

	return ga.bind(window);
}

export function initializeGtagTracking(gtagCodes, ga4Code) {
	(function (i, s, o, g, r, a, m) {
		i["GTAGObject"] = r;
		(i[r] =
			i[r] ||
			function () {
				(i[r].q = i[r].q || []).push(arguments);
			}),
			(i[r].l = 1 * new Date());
		(a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
		a.async = 1;
		a.src = g;
		!m || m.parentNode.insertBefore(a, m);
	})(
		window,
		document,
		"script",
		"https://www.googletagmanager.com/gtag/js?id=" + gtagCodes[0],
		"ga"
	);

	window.dataLayer = window.dataLayer || [];
	const gtag = function () {
		window.dataLayer.push(arguments);
	};
	gtag.bind(window);

	gtag("js", new Date());

	for (let i = 0; i < gtagCodes.length; i++) {
		gtag("config", gtagCodes[i], {
			send_page_view: false,
			groups: GOOGLE_ADS_GROUP,
		});
	}

	if (ga4Code) {
		gtag("config", ga4Code, {
			send_page_view: false,
		});
	}

	return gtag;
}
